import { EnvironmentProviders } from '@angular/core';
import { EgBrandOptions, provideEgBrand } from '@expertgroup/shell';
import type { EgLoadedBrand } from '@expertgroup/shell/brand';

/**
 * Identity's default mask (shell 0.16, „maska"): the product name, and no logo and no mark of its own — `''`, so the rail
 * never falls back to the shell's built-in Expert Group logo. It is the generic look: what a host without a mask shows
 * (localhost, the Static Web App hosts, a host no tenant has claimed) and what a page shows when Identity did not answer.
 */
export const IDENTITY_BRAND: EgBrandOptions = { productName: 'Identity', logoSrc: '', markSrc: '' };

/**
 * The mask of this page: the host's, from Identity (`loadEgBrand` in main.ts, before bootstrap), over the default. The host
 * always wins — whoever signs in, `identity.fabrikam.com` wears Fabrikam's mask — so nothing here waits for the actor. The
 * loader never sends a key with an `undefined` value, so the spread keeps every default the host's mask does not set, and
 * `null` (no mask for this host) spreads into nothing.
 */
export function provideIdentityBrand(brand: EgLoadedBrand | null): EnvironmentProviders {
    return provideEgBrand({ ...IDENTITY_BRAND, ...(brand ?? {}) });
}
